import { createContext, useContext } from 'react';

// Контекст группы экранов, показанной табами. Живёт отдельно от компонентов,
// чтобы react-refresh не ругался на файл со смешанными экспортами.
//
// Табы — это НАВИГАЦИЯ по обычным роутам, а не локальный стейт: URL остаётся
// адресуемым (deep-link, refresh, кнопка «назад»), подпункты меню продолжают
// работать, состояние каждого экрана живёт своей жизнью.
export type ScreenTab = {
  id: string;
  path: string;
  label: string;
};

export type ScreenTabsValue = {
  tabs: ScreenTab[];
  // Заголовок раздела, общий для всех экранов группы: при переключении табов
  // он не меняется, поэтому PageHeader показывает его вместо title страницы.
  title: string;
  // Табы-сегменты только ниже lg (NavGroup.compactTabs): заголовок страницы
  // остаётся своим, а на lg+ таб-бара нет — там подпункты в сайдбаре.
  compact?: boolean;
};

export const ScreenTabsContext = createContext<ScreenTabsValue | null>(null);

// null — экран вне группы табов: PageHeader рисует обычный заголовок страницы.
export const useScreenTabs = () => useContext(ScreenTabsContext);
